import { render } from "./MetricsContainer.vue?vue&type=template&id=631305dc&scoped=true"
import script from "./MetricsContainer.vue?vue&type=script&lang=js"
export * from "./MetricsContainer.vue?vue&type=script&lang=js"

import "./MetricsContainer.vue?vue&type=style&index=0&id=631305dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631305dc"]])

export default __exports__